<template>
    <transition appear enter-active-class="animated bounceInRight">
        <f7-view main>
            <f7-page>
                <!-- header -->
                <cm-navbar :title="$ml.get('purchaseOrders')">
                    <f7-nav-right><f7-link @click="save">{{ $ml.get('save') }}</f7-link></f7-nav-right>
                </cm-navbar>
                <!-- END header -->

                <!-- body -->
                <f7-block-title>{{ $ml.get('basicInfo') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>
                    <f7-list-input type="text" :label="$ml.get('pocode')" clear-button :value="form.code" @input="form.code = $event.target.value" name="code" v-validate="'required'"></f7-list-input>

                    <f7-list-item :title="$ml.get('material')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="material_id" v-model="form.material_id" v-validate="'required'">
                            <option v-for="item in materials" :value="item.id" :key="item.id">[{{ item.materialtype.name }}] {{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('containers')" smart-select :smart-select-params="{openIn: 'page', searchbar: true}">
                        <select name="container_id" multiple v-model="form.container_id" v-validate="'required'">
                            <optgroup v-for="(type, index1) in containers" :key="index1" :label="type.name">
                                <option v-for="(container, index2) in type.containers" :key="index2" :value="container.id">{{ container.inventory.code }}: {{ container.name }} ({{ $ml.get('space') }}: {{ $helper.numFormat(container.max_capacity - container.capacity) }})</option>
                            </optgroup>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('bin')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="bin" v-model="form.bin">
                            <option v-for="item in $constant.bins" :value="item" :key="item">{{ item }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-input type="number" :label="$ml.get('amount')" placeholder="0" clear-button :value="form.amount" @input="form.amount = $event.target.value" name="amount" v-validate="'required'"></f7-list-input>

                    <f7-list-input v-if="$helper.hasPermission('can_change_price_poraw')" type="number" :label="$ml.get('price')" placeholder="0" clear-button :value="form.price" @input="form.price = $event.target.value" name="price"></f7-list-input>

                    <f7-list-item :title="$ml.get('supplier')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="supplier_id" v-model="form.supplier_id" v-validate="'required'">
                            <option v-for="item in suppliers" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-input type="text" :label="$ml.get('notes')" clear-button :value="form.note" @input="form.note = $event.target.value" name="note"></f7-list-input>

                    <f7-list-input v-if="showSolo" type="text" :label="$ml.get('solo')" clear-button :value="form.solo" @input="form.solo = $event.target.value" name="solo"></f7-list-input>

                    <f7-list-item :title="$ml.get('addSupplier')" @click="showPopup">
                        <i class="f7-icons" slot="media">add</i>
                    </f7-list-item>
                </f7-list>

                <f7-block-title>{{ $ml.get('advancedInfo') }}</f7-block-title>
                <f7-list inline-labels no-hairlines-md>

                    <f7-list-input type="text" :label="$ml.get('vehicleNo')" placeholder="67A1 - 123.12" clear-button :value="form.vehicle_no" @input="form.vehicle_no = $event.target.value" name="vehicle_no"></f7-list-input>
                    <f7-list-input type="text" :label="$ml.get('vehicleOwner')" clear-button :value="form.vehicle_owner" @input="form.vehicle_owner = $event.target.value" name="vehicle_owner"></f7-list-input>

                    <f7-list-item :title="$ml.get('field')" smart-select :smart-select-params="{openIn: 'page', closeOnSelect: true, searchbar: true}">
                        <select name="field_id" v-model="form.field_id">
                            <option v-for="item in sFields" :value="item.id" :key="item.id">{{ item.name }}</option>
                        </select>
                    </f7-list-item>

                    <f7-list-item :title="$ml.get('documents')">
                        <input type="file" ref="fileupload" multiple v-on:change="fileChange($event.target.files)" />
                    </f7-list-item>
                </f7-list>
                <!-- END body -->

                <!-- POPUP -->
                <f7-popup class="demo-popup" :opened="popupOpened" @popup:closed="closePopup">
                    <f7-view>
                        <f7-page>
                            <f7-navbar :title="$ml.get('addSupplier')">
                                <f7-nav-right><f7-link popup-close>{{ $ml.get('close') }}</f7-link></f7-nav-right>
                            </f7-navbar>

                            <f7-list inline-labels no-hairlines-md>
                                <f7-list-input type="text" :label="$ml.get('fullname')" clear-button @input="customer.name = $event.target.value" name="name"></f7-list-input>
                                <f7-list-input type="text" :label="$ml.get('address')" clear-button @input="customer.address = $event.target.value"></f7-list-input>
                            </f7-list>

                            <f7-block>
                                <f7-button fill round @click="addSupplier">{{ $ml.get('save') }}</f7-button>
                            </f7-block>
                        </f7-page>
                    </f7-view>
                </f7-popup>
                <!-- END POPUP -->
            </f7-page>
        </f7-view>
    </transition>
</template>

<script>
    import Query    from '@/services/api/Query'
    import Mutation from '@/services/api/Mutation'
    import CMNavbar from './Navbar'
    const lo        = require('lodash')

    export default {
        name: 'FromAddPO',
        props: {},
        components: {
            'cm-navbar': CMNavbar,
        },
        data() {
            return {
                form: {
                    bin: '',
                    code: '',
                    amount: '',
                    price: null,
                    vehicle_no: '',
                    material_id: null,
                    supplier_id: '',
                    field_id: 0,
                    container_id: [],
                    inputsourcetype_id: 1,
                    documents: null,
                    solo: '',
                    note: '',
                    vehicle_owner: '',
                },
                customer: {
                    name: null,
                    address: null,
                },
                sFields: [],
                materials: [],
                suppliers: [],
                containers: [],
                files: null,
                popupOpened: false,
                showSolo: false,
            }
        },
        methods: {
            resetForm() {
                this.form = {
                    bin: '',
                    code: '',
                    amount: '',
                    price: null,
                    vehicle_no: '',
                    material_id: null,
                    supplier_id: '',
                    field_id: 0,
                    container_id: [],
                    inputsourcetype_id: 1,
                    documents: null,
                    solo: '',
                    note: '',
                    vehicle_owner: '',
                }
                this.files = null
                this.$refs.fileupload.value = null
                this.$helper.clearAll()
            },

            fileChange(fileList) {
                this.files = fileList
                this.form.documents = '$files'
            },

            closePopup() {
                this.popupOpened = false
            },

            showPopup() {
                this.popupOpened = true
            },

            async getContainers(material_id = 0) {
                let result      = await Query.withContainersByType({'material_id': material_id, 'strict': null}).get()
                this.containers = this.$helper.data(result, 'container_by_type')
            },

            async getFields(supplier_id) {
                let result  = await Query.withFields(supplier_id).get()
                this.sFields = this.$helper.data(result, 'fields')
            },

            async addSupplier() {
                this.$f7.dialog.preloader(this.$ml.get('processing'))
                let result = await Mutation.addSupplier(this.customer).execute()
                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)
                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                let formData = await Query.withSuppliers().get()
                this.suppliers = this.$helper.data(formData, 'suppliers')
                this.$f7.dialog.close()
                this.closePopup()

                return this.$f7.dialog.alert(this.$ml.get('success.addSupplier'), this.$ml.get('information'))
            },

            async save() {
                if (! await this.$validator.validateAll())
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredAll'), this.$ml.get('errors.title'))
                if (this.showSolo && (! this.form.solo || this.form.solo === ''))
                    return this.$f7.dialog.alert(this.$ml.get('errors.requiredSolo'), this.$ml.get('errors.title'))
                if (this.form.amount <= 0)
                    return this.$f7.dialog.alert(this.$ml.get('errors.greaterZero'), this.$ml.get('errors.title'))

                this.$f7.dialog.preloader(this.$ml.get('processing'))
                /* prepare form data && submit */
                let params          = lo.clone(this.form)
                params.container_id = this.$helper.toString(params.container_id)
                let result          = await Mutation
                    .addFiles(this.files)
                    .addPO(params)
                    .execute()

                /* check & show error */
                if (result.data.errors) {
                    this.$f7.dialog.close()
                    let message = this.$helper.errors(result.data.errors)
                    return this.$f7.dialog.alert(message, this.$ml.get('errors.title'))
                }

                this.$f7.dialog.close()
                return this.$f7.dialog.alert(
                    this.$ml.get('success.addPO'),
                    this.$ml.get('information'),
                    () => this.resetForm()
                )
            },
        },

        async created() {
            let formData   = await Query.withMaterials('LNLNL,LNLNLS,LNLBTP,LNLPP').withSuppliers().get()
            this.materials = this.$helper.data(formData, 'materials')
            this.suppliers = this.$helper.data(formData, 'suppliers')
            await this.getContainers(this.materials[0].id || 0)
        },

        watch: {
            'form.material_id' (val) {
                this.getContainers(val)
            },
            'form.supplier_id' (val) {
                this.getFields(val)
            },
            'form.container_id' (val) {
                this.containers.forEach((item) => {
                    item.containers.forEach((container) => {
                        if (val.length > 0 && val.includes(container.id)) {
                            if (! container.solo || container.solo === '') {
                                this.showSolo = true
                            }
                        } else if (val.length === 0) {
                            this.showSolo = false
                        }
                    })
                })
            },
        },
    }
</script>